import { render, staticRenderFns } from "./subcontract.vue?vue&type=template&id=47433814&scoped=true"
import script from "./subcontract.vue?vue&type=script&lang=js"
export * from "./subcontract.vue?vue&type=script&lang=js"
import style0 from "./subcontract.vue?vue&type=style&index=0&id=47433814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47433814",
  null
  
)

export default component.exports